var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('logo');
import { useLogo } from '../../hooks/use-logo';
/**
 * This component is needed so that we can easily turn a logo provided by the LogoProvider into a styled component, g
 * given that styled components are defined outside of the body of a React.FC, and this needs to use a hook INSIDE a render function to pull the logo from LogoContext).
 *
 * NB: This component doesn't really do anything without wrapping it inside a <LogoProvider> with value as the component to use for rendering the logo.
 * It just provides a standard mechanism for rendering a component provided by that context
 */
// -------- Components -------->

export var Logo = function Logo(props) {
  var Logo = useLogo();
  return React.createElement(Logo, __assign({}, props));
};